export const graceOptions = [
  { id: "1", name: "1 day", value: 1 },
  { id: "2", name: "2 day", value: 2 },
  { id: "3", name: "3 day", value: 3 },
];

export const relationOptions = [
  { id: "1", name: "Father", value: "Father" },
  { id: "2", name: "Mother", value: "Mother" },
  { id: "3", name: "Grandfather", value: "Grandfather" },
  { id: "4", name: "Grandmother", value: "Grandmother" },
  { id: "5", name: "Father-in-law", value: "Father-in-law" },
  { id: "6", name: "Mother-in-law", value: "Mother-in-law" },
  { id: "7", name: "Grandfather-in-law", value: "Grandfather-in-law" },
  { id: "8", name: "Grandmother-in-law", value: "Grandmother-in-law" },
  { id: "9", name: "Son", value: "Son" },
  { id: "10", name: "Daughter", value: "Daughter" },
  { id: "11", name: "Brother", value: "Brother" },
  { id: "12", name: "Sister", value: "Sister" },
];

export const familyTypeOptions = [
  { id: "1", name: "Nuclear Family", value: "Nuclear Family" },
  { id: "2", name: "Joint Family", value: "Joint Family" },
  { id: "3", name: "Childless family", value: "Childless family" },
  { id: "4", name: "Step Family", value: "Step Family" },
  { id: "5", name: "Grandparent Family", value: "Grandparent Family" },
];
